/* hs-eslint ignored failing-rules */
/* eslint-disable require-await */
/* eslint-disable hubspot-dev/no-async-await */

import http from 'hub-http/clients/apiClient';
const BASE_URI = 'filemanager/api/v3/folders';
export const setFolderPermissions = async (folderIds, teams) => Promise.all(folderIds.toArray().map(folderId => http.post(`${BASE_URI}/${folderId}/partition`, {
  data: teams
})));